import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import { DepositNotes } from "@app/models/deposit-notes";

@Injectable({
    providedIn: 'root'
})
export class DepositNotesService extends BaseRestService {

    readonly DEPOSIT_NOTE_URL: string = environment.depositUri + '/api/deposit-notes';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.DEPOSIT_NOTE_URL, options);
    }

    getDepositById(id): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.DEPOSIT_NOTE_URL + '/' + id, options);
    }

    create(data: DepositNotes): Observable<any> {
        return this.httpClient.post(this.DEPOSIT_NOTE_URL, JSON.stringify(data),
            { headers: this.headers });
    }

    update(accountType: DepositNotes): Observable<any> {
        return this.httpClient.put(this.DEPOSIT_NOTE_URL + '/' + accountType.id, JSON.stringify(accountType),
            { headers: this.headers });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.DEPOSIT_NOTE_URL + "/" + id,
            { headers: this.headers });
    }

   findDepositNoteParents(depositNote: DepositNotes, depositNotes: Array<DepositNotes>) {
        let items = [];
        if (depositNote) {
          items.push(depositNote);
          if (depositNotes && depositNotes.length > 0) {
            var parentItem = this.findDepositNoteById(depositNote.parentDepositNoteId, depositNotes);
            if (parentItem) {
              items = items.concat(this.findDepositNoteParents(parentItem, depositNotes));
            }
          }
        }
        return items;
    }

findDepositNoteById(id: string, items: Array<DepositNotes>) {
        if (id) {
          if (items && items.length > 0) {
            var item = items.find((p) => p.id == id);
            if (item) {
              return item;
            }

            for (var i = 0; i < items.length; i++) {
              var item = this.findDepositNoteById(id, items[i].subDepositNotes);
              if (item) {
                return item;
              }
            }
          }
        }
        return undefined;
    }
}